import './AdvancedSearchModal.scss';

const AdvancedSearchModal = (data: any) => {
  const advancedData = data?.data;

  return (
    <div className="AdvancedModal_Container">
      <table>
        <tbody>
          <tr>
            <td className="Title">Min Loaded RPM</td>
            <td className="Values">
              {advancedData?.minRPM ? `$${advancedData?.minRPM.toFixed(2)}` : 'No Min'}
            </td>
          </tr>
          <tr>
            <td className="Title">Load Distance Minimum</td>
            <td className="Values">{advancedData?.minMiles}</td>
          </tr>
          <tr>
            <td className="Title">Load Distance Maximum</td>
            <td className="Values">{advancedData?.maxMiles}</td>
          </tr>
          <tr>
            <td className="Title">Load Exclusions</td>
            <td className="Values">
              {advancedData?.excludeSpecialServices &&
                advancedData?.excludeSpecialServices.map((exclusion: string, index: number) => (
                  <p key={index}>{exclusion.toUpperCase()}</p>
                ))}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default AdvancedSearchModal;
